import React from "react";
import { SPORTS } from "../lib/api";

export default function SportPills({ value, onChange, includeAll = true }) {
  return (
    <div className="flex gap-2 overflow-x-auto scrollbar-hide -mx-4 px-4 py-1">
      {includeAll && (
        <button
          data-testid="sport-pill-all"
          onClick={() => onChange(null)}
          className={`shrink-0 px-4 py-2 rounded-full text-sm font-bold transition-all ${value === null ? "bg-primary text-primary-foreground glow-cyan" : "bg-secondary text-secondary-foreground border border-border"}`}
        >
          Semua
        </button>
      )}
      {SPORTS.map((s) => (
        <button
          key={s.id}
          data-testid={`sport-pill-${s.id}`}
          onClick={() => onChange(s.id)}
          className={`shrink-0 flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold transition-all ${value === s.id ? "bg-primary text-primary-foreground glow-cyan" : "bg-secondary text-secondary-foreground border border-border hover:border-primary/40"}`}
        >
          <span>{s.icon}</span> {s.label}
        </button>
      ))}
    </div>
  );
}
